var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"b-link b-link_primary",attrs:{"href":_vm.plan.provider.url}},[_vm._v(_vm._s(_vm.plan.provider.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }